import { apiClient } from '@shared/api/client';
import { ApiResponse } from '@shared/api/api.types';
import { AvailableRoleContextsDTO } from '../dtos';

export const roleContextApi = {
  // Get available role contexts for current user
  async getAvailableRoleContexts(): Promise<ApiResponse<AvailableRoleContextsDTO>> {
    return apiClient.get<AvailableRoleContextsDTO>('/role-context/available');
  },
};
